import {defaultClassNames, SORTABLE_DIRECTION, SORTABLE_POSITION} from '../../constants';
import {removeTargetList} from './removeTargetList';

import type {SortableDirection, SortablePosition} from '../../typedef';

type SetActiveClass = (params: {
    direction: SortableDirection,
    position: SortablePosition,
    onHover: () => void,
    targetElement: HTMLElement | null,
}) => void;

export const setActiveClass: SetActiveClass = ({direction, position, onHover, targetElement}) => {
    const targetBefore = direction === SORTABLE_DIRECTION.HORIZONTAL ?
        defaultClassNames.targetLeft : defaultClassNames.targetTop;
    const targetAfter = direction === SORTABLE_DIRECTION.HORIZONTAL ?
        defaultClassNames.targetRight : defaultClassNames.targetBottom;

    if (targetElement) {
        const {classList} = targetElement;

        if (position === SORTABLE_POSITION.AFTER) {
            if (!classList.contains(targetAfter)) {
                classList.add(targetAfter);
                onHover();
            }

            if (classList.contains(targetBefore)) {
                classList.remove(targetBefore);
            }
        } else if (position === SORTABLE_POSITION.BEFORE) {
            if (!classList.contains(targetBefore)) {
                classList.add(targetBefore);
                onHover();
            }
            if (classList.contains(targetAfter)) {
                classList.remove(targetAfter);
            }
        } else {
            removeTargetList(targetElement);
        }
    }
};
